import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import SEO from '../components/seo';
import Header from '../components/header';
import FullPageLoader from '../components/full-page-loader';

import 'bootstrap-sass/assets/stylesheets/_bootstrap.scss';
import '../styles/style.scss';
import Footer from '../components/footer';

const StyledMain = styled.main`
  min-height: calc(calc(100vh - 54px) - 165px);
`;
export default function Layout({ children, title, description }) {
  const { t, ready } = useTranslation('application', { useSuspense: false });
  const loading = useSelector(({ application }) => application.loading);
  if (loading || !ready) {
    return <FullPageLoader />;
  }
  return (
    <>
      <SEO
        title={title || t('common.meta.title')}
        description={description || t('common.meta.description')}
      />
      <Header />
      <StyledMain className="container">{children}</StyledMain>
      <Footer />
    </>
  );
}

Layout.defaultProps = {};
Layout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
};
